<ion-list>
  <ion-item lines="none" detail="true" button="true" (click)="onCreateCustomLocation()" *ngIf="loggedIn">
    <curbnturf-site-svgs slot="start" type="rvtrip"></curbnturf-site-svgs>
    <ion-label>Add Custom Point</ion-label>
  </ion-item>
  <ion-item lines="none" detail="true" button="true" (click)="onCreateListing('standard')">
    <curbnturf-site-svgs slot="start" type="plus"></curbnturf-site-svgs>
    <ion-label>Add Property</ion-label>
  </ion-item>
  <ion-item lines="none" detail="true" button="true" (click)="onCreateListing('boondock')">
    <curbnturf-site-svgs slot="start" type="forest"></curbnturf-site-svgs>
    <ion-label>Add Boondock</ion-label>
  </ion-item>
  <ion-item lines="none" detail="true" button="true" (click)="onBeginAddPoi()">
    <curbnturf-category-svg slot="start" icon="activity"></curbnturf-category-svg>
    <ion-label>Add POI</ion-label>
  </ion-item>
</ion-list>
